import { LABELS_TYPE, LABELS_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { StringValue } from '../../../value/types.tsx';

const getLabelsValue: StringValue<{
	fieldId: string;
	type: typeof LABELS_TYPE | typeof LABELS_CF_TYPE;
	value: Array<string | null>;
}> = (field) => String(field.value.join(', ') || '');

export const labelsStringValueHandler = {
	[LABELS_TYPE]: getLabelsValue,
	[LABELS_CF_TYPE]: getLabelsValue,
};
